module.exports = __webpack_public_path__ + "static/viernes-20-11-9c923c3653c9d7e204fd047fbc2c258a.jpg";